import prepareAacrDemo from "./prepareAacrDemo.js";
import aacrP2Images from './aacrP2Images.json'
import FIGURES from './FIGURES.json';


import { createStore, applyMiddleware } from 'redux';


import onQuantificationParametersChange from './onQuantificationParametersChange';

import Reducer from './UndoRedoReducer';


import DefaultState from './DefaultState';
import C from './Constants';

import { enableBatching } from 'redux-batched-actions';

import thunk from 'redux-thunk';

/* 100 ms to import */
import { composeWithDevTools } from 'remote-redux-devtools';

//import { composeWithDevTools } from '@redux-devtools/extension';

import paywallMiddleware from './paywallMiddleware';

//import testDashboard from './testDashboard';

import addActionArgsOverridesMiddleware from './addActionArgsOverridesMiddleware';

import analyticsMiddleware from './analyticsMiddleware';

import {ignoreActionsOnCliServerError} from './customMiddleware';

import { isUsingWebdriver } from './versionConfig';

import A from './ActionCreators';

export default function initStore(args){
 let {
   initialState,
   remoteDevTools,
   devtoolsName,
   windowSessionId,
   personId,
   agentId,
   providedDirectoryRoots
 } = args || {};


  let actionSanitizerPrepMiddleware = [ ]
  if( process.env.NODE_ENV !== 'production' ){
    //actionSanitizerPrepMiddleware.push(actionSanitizerPrep);
  }

  let middlewares;
  
  middlewares=[
    //memoryUsageMiddleware,
    /*testDashboard,*/
    paywallMiddleware,
    analyticsMiddleware,
    onQuantificationParametersChange,
    thunk,
    ...actionSanitizerPrepMiddleware,
    ignoreActionsOnCliServerError,
  ];

  if( isUsingWebdriver() ){

    middlewares.push(
      addActionArgsOverridesMiddleware
    )
  }



  if( typeof(window) !== typeof(undefined) && process.env.NODE_ENV !== 'production' ){

    window.__sessionActions = []
    const fun = store => next => action => {
      window.__sessionActions.push(action);
      return next(action);
    }

    //middlewares.splice(2,0,fun);

  }

  /*if( !remoteDevTools ){
    return createStore(
      Reducer,
      applyMiddleware(...middlewares)
    )
  }*/

 
  let name;
  if( typeof(window)===typeof(undefined) ){
    name = "CLI Test";
  }else{
    if( !!navigator.webdriver ){
      name = "Selenium";
    }else{
      name = undefined;
    }
  }

  

  let lastStoreCreationArg;
  if( remoteDevTools ){

    // look for this
    // to see if devtools 
    // is running:
    // ps aux... grep for this: 
    //  `sh -c remotedev --hostname=localhost --port=8000`

    //let composeWithDevTools = require('remote-redux-devtools').composeWithDevTools;


    let devtoolsArgs = {
      name,
      host:'localhost',
      realtime:true, 
      port:8000, 
      trace: true,
      //traceLimit:25,
      maxAge: 100,
      suppressConnectErrors:false,
      pingInterval:5 * 60 * 1000,
      pingTimeout: 120000,
      //actionSanitizer
    }
                                                                                                
    let composeEnhancers = composeWithDevTools(devtoolsArgs);
    if (typeof(window) !== typeof(undefined)){
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || composeEnhancers;
    }



    lastStoreCreationArg = composeEnhancers( applyMiddleware( ...middlewares ) ) 


  }else{
    lastStoreCreationArg = applyMiddleware(...middlewares)
  }
    


  let resolvedInitialState;

  if( initialState ){
    
    resolvedInitialState = initialState;
  }else{
    
    resolvedInitialState = DefaultState({
      providedDirectoryRoots,
      windowSessionId,personId,agentId})
  }



  const store = createStore(
    //Reducer,
    enableBatching(Reducer),
    resolvedInitialState,
    lastStoreCreationArg,
  )

  //prepareAacrDemo(store);




  /*
  if( false ){
    let { dimensions, clusters } = FIGURE_DATA;


    Object.entries(dimensions).forEach(entry => {
      let [ fn, dims ] = entry;
      let [ height, width ] = dims;
      store.dispatch(A.startImageUploads({ "filenames": [fn], imageIds:[fn], imageSetIds:[fn], heights:[ height/width ], urls:[fn],"uploadWidths":[width], grayscale:[false,false,false] })) 
    })

    clusters.forEach((figure,ii) => {

      let { grid, cellGroups, columnWidths } = figure;

      let gel = columnWidths;
      let left = 1;
      let right = 0;



      let args = { left, gel, right, grid, cellGroups, columnWidths };

      store.dispatch(A.createItem({ _id:ii+1, figurePanelType:"westernBlot", itemType:"figurePanels", args }))
    })
  }
  */

  let fn = "/output/5-output/0166b5f4-c521-473a-973b-65662f3a76c9.png"
  let state = store.getState();
  let _custom = state.data.figurePanels['custom'];
  return store;


}
